export var IconPrefix;
(function (IconPrefix) {
    IconPrefix["FontAwesome"] = "fa-";
})(IconPrefix || (IconPrefix = {}));
export var IconSet;
(function (IconSet) {
    IconSet["FALight"] = "fal";
    IconSet["FABrand"] = "fab";
})(IconSet || (IconSet = {}));
export var IconCssClass;
(function (IconCssClass) {
    IconCssClass["Base"] = "iress-icon";
    IconCssClass["Icon"] = "iress-icon__icon";
    IconCssClass["SrOnly"] = "iress-sr-only";
    IconCssClass["Rotate"] = "iress-icon--rotate";
    IconCssClass["Flip"] = "iress-icon--flip";
    IconCssClass["Spin"] = "iress-icon--spin";
    IconCssClass["FixedWidth"] = "fa-fw";
})(IconCssClass || (IconCssClass = {}));
export var IconSize;
(function (IconSize) {
    IconSize["Xs"] = "xs";
    IconSize["Sm"] = "sm";
    IconSize["Lg"] = "lg";
    IconSize["TwoTimes"] = "2x";
    IconSize["ThreeTimes"] = "3x";
    IconSize["FiveTimes"] = "5x";
    IconSize["SevenTimes"] = "7x";
    IconSize["TenTimes"] = "10x";
})(IconSize || (IconSize = {}));
export var IconFlip;
(function (IconFlip) {
    IconFlip["Both"] = "both";
    IconFlip["Horizontal"] = "horizontal";
    IconFlip["Vertical"] = "vertical";
})(IconFlip || (IconFlip = {}));
export var IconRotate;
(function (IconRotate) {
    IconRotate["Deg180"] = "180";
    IconRotate["Deg270"] = "270";
    IconRotate["Deg90"] = "90";
})(IconRotate || (IconRotate = {}));
export var IconSpin;
(function (IconSpin) {
    IconSpin["SpinHalf"] = "half";
    IconSpin["Spin1"] = "1";
    IconSpin["Spin2"] = "2";
    IconSpin["Spin3"] = "3";
})(IconSpin || (IconSpin = {}));
//# sourceMappingURL=icon.types.js.map